function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.0199 16.7346C16.4284 16.7346 16.8071 16.5453 17.2455 16.1069L25.9139 7.52808C25.5453 7.16938 24.8578 7 23.8714 7H7.82971C6.99275 7 6.40489 7.15942 6.07609 7.48822L14.7944 16.1069C15.2228 16.5353 15.6014 16.7346 16.0199 16.7346ZM5.24909 22.5634L12.2935 15.5987L5.22917 8.63406C5.07971 8.91304 5 9.3913 5 10.0788V21.0788C5 21.7862 5.07971 22.2844 5.24909 22.5634ZM26.7609 22.5534C26.9203 22.2645 27 21.7763 27 21.0788V10.0788C27 9.41123 26.9203 8.93297 26.7808 8.66395L19.7364 15.5987L26.7609 22.5534ZM24.1703 24.1676C25.0072 24.1676 25.5851 24.0082 25.9139 23.6893L18.7301 16.5752L18.0725 17.2428C17.385 17.9004 16.7373 18.1993 16.0199 18.1993C15.2926 18.1993 14.6449 17.9004 13.9674 17.2428L13.2998 16.5752L6.13587 23.6793C6.51449 24.0082 7.1721 24.1676 8.12862 24.1676H24.1703Z",
  fill: "#F5F6F6"
});

var SvgMail = function SvgMail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail.a3683057.svg";
export { ForwardRef as ReactComponent };